import axios from 'axios';
import qs from 'qs';
import router from '../router';
import {Message, MessageBox} from 'element-ui';
import utils from '../utils/utils'
// create an axios instance
const service = axios.create({
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'urlHash': location.hash
  },
});
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  },
);
// response interceptor
service.interceptors.response.use(
  (response) => {
    if (response.config.url.indexOf('sysConfig/upload') < 0) {
      const res = response.data;
      if (res && res.code !== 0) {
        if (response.config.url.indexOf('wechat/publicxiaochengxu') > 0) {
          let msg = utils.errCoode2Msg(res.code);
          Message.error(msg)
        } else if (res.code !== 1) {
          Message.error(res.msg)
        }
        return Promise.reject(res)
      }
      if (res && res.obj && res.obj.errcode && res.obj.errcode > 0) {
        if (res.code !== 1) {
          Message.error(res.obj.errmsg)
        }
        return Promise.reject(res)
      }
    }

    return response;
  },
  (error) => {
    console.log(error.response); // for debug
    const {response} = error;
    // const isCurrent = error.config.headers.urlHash == location.hash;
    // if (isCurrent == true ){
    if (response.status === 500) {
      const msg = response.data.message;
      if (msg && msg !== 'No message available') {
        Message.error(msg);
      } else {
        MessageBox.alert('服务器返回异常[' + response.data.error + ']', '提示').then(() => {
          router.push({path: '/'})
        });
      }
      return Promise.reject(error);
    }
    //}
    if (parseInt(response.status / 400) === 1) {
      Message.error("请求错误")
    }
    return Promise.reject(error);
  },
);
const get = (api, data) => {
  const self = this;
  if (data) {
    api += "?" + qs.stringify(data);
  }
  return service.get(api);
}
const post = (api, data) => {
  const self = this;
  return service.post(api, data)
}
const put = (api, id, data) => {
  const self = this;
  return service.put(api + '?id=' + id, data);
}
const del = (api, id) => {
  const self = this;
  return service.delete(api + '?id=' + id);
}
const upload = (api, data, headers) => {
  return service.post(api, data, headers)
}
export default {
  get, post, put, del, upload
};



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js